<section class="-my-9 py-7">
  <div class="mask-curve-top-div bg-gray-light"></div>
  <div class="bg-gray-light">
    <div class="centered-with-padding py-12">
      @if (data.title; as title) {
        <div class="max-w-[500px]">
          <app-title [title]="title" size="h2" />
        </div>
      }
      @defer (on idle; on timer(5s)) {
        <div class="py-5">
          <app-flowbox />
        </div>
      }
      @if (data.hashtag; as hashtag) {
        <div class="text-right font-title text-[30px]">{{ hashtag }}</div>
      }
    </div>
  </div>
  <div class="mask-curve-bottom-div bg-gray-light"></div>
</section>
